// extracted by mini-css-extract-plugin
module.exports = {"root":"RejectedIcon-root-92d42ee92fe2bde85885ab5ca594aa67"};